import React from "react";

const SvgCarousel = props => (
  <svg viewBox="0 0 100 100" {...props}>
    <path d="M34.123 20.846h31.709v53.57H34.123zM27.93 30.022v35.217h-7.015V30.022h7.015m2.834-2.834H18.08v40.886h12.684V27.188zM69.189 27.188h12.686v40.886H69.189zM85.232 31.549h8.513v32.164h-8.513zM6.208 31.549h8.513v32.164H6.208z" />
  </svg>
);

export default SvgCarousel;
